export const lightTheme = {
  mode: 'light',
  colors: {
    background: '#f1f4f9',
    surface: '#ffffff',
    surfaceElevated: '#f8fafc',
    surfaceMuted: '#eef2f7',
    textPrimary: '#0f172a',
    textSecondary: '#475569',
    border: '#e2e8f0',
    inputBackground: '#ffffff',
    inputBorder: '#cbd5e1',
    primary: '#7085ff',
    primaryHover: '#5f74ef',
    primaryActive: '#4d63d3',
    onPrimary: '#ffffff',
    muted: '#94a3b8',
    success: '#10b981',
    danger: '#ef4444',
    cardShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
    overlay: 'rgba(255, 255, 255, 0.88)',
    headerGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    heroGradient: 'linear-gradient(135deg, #667eea 0%, #6c5ae0 100%)',
    footerGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    tableRowAlt: '#f3f4f6',
    tableRowHover: '#e5e7eb',
    badge: 'rgba(255, 255, 255, 0.2)',
  },
}

export const darkTheme = {
  mode: 'dark',
  colors: {
    background: '#0b1220',
    surface: '#0f172a',
    surfaceElevated: '#131d32',
    surfaceMuted: '#111827',
    textPrimary: '#e2e8f0',
    textSecondary: '#94a3b8',
    border: '#1f2a3d',
    inputBackground: '#131d32',
    inputBorder: '#2b3852',
    primary: '#8da4ff',
    primaryHover: '#7f95ef',
    primaryActive: '#6c7fda',
    onPrimary: '#0b1020',
    muted: '#6b7280',
    success: '#34d399',
    danger: '#f87171',
    cardShadow: '0 10px 30px rgba(0, 0, 0, 0.45)',
    overlay: 'rgba(0, 0, 0, 0.75)',
    headerGradient: 'linear-gradient(135deg, #1f2a44 0%, #1a2a55 100%)',
    heroGradient: 'linear-gradient(135deg, #1f2a44 0%, #1a2a55 100%)',
    footerGradient: 'linear-gradient(135deg, #1f2a44 0%, #1a2a55 100%)',
    tableRowAlt: '#111827',
    tableRowHover: '#1f2937',
    badge: 'rgba(255, 255, 255, 0.12)',
  },
}
